import { render, staticRenderFns } from "./EnteralNutrition.vue?vue&type=template&id=d2798920&scoped=true"
import script from "./EnteralNutrition.vue?vue&type=script&lang=js"
export * from "./EnteralNutrition.vue?vue&type=script&lang=js"
import style0 from "./EnteralNutrition.vue?vue&type=style&index=0&id=d2798920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2798920",
  null
  
)

export default component.exports